import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../auth.store'
import AuthLayout from './AuthLayout'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { accessToken, customer } = useAuthStore()

  // Only redirect if user is fully authenticated (has both token and customer profile)
  // Temporary tokens from password reset flow should not trigger redirect
  if (accessToken && customer) {
    // Redirect authenticated users to dashboard
    return <Navigate to="/" replace />
  }

  return (
    <AuthLayout>
      {children}
    </AuthLayout>
  )
}

